export const fwCssVariablePrefix = '--fw-' as const
export const fwCssVariableColorPrefix = `${fwCssVariablePrefix}color-` as const

export type FwCssVariableColor = `${typeof fwCssVariableColorPrefix}${string}`
